import React from "reactn";

import "../scss/table.scss";

const Table = props => <table {...props} cellPadding="0" cellSpacing="0" className={"table " + (props.className || "")}>{props.children}</table>;

export default Table;